module.exports = __webpack_public_path__ + "static/media/mysql-arch.df85423b.png";